// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import MomentUtils from '@date-io/moment';
import * as moment from 'moment';

export default class DateUtils extends MomentUtils {
  date(value: string | Date) {
    return moment.utc(value);
  }
}

export const isDateEqualNoTime = (date1: string, date2: string): boolean => {
  var d1 = new Date(date1);
  var d2 = new Date(date2);
  
  return d1.getFullYear() == d2.getFullYear() && d1.getMonth() == d2.getMonth() && d1.getDate() == d2.getDate();
}